import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { _className } from '../../utils/tools.js';
export class TS_Space extends React.Component {
    render() {
        return _jsx("div", { className: _className('ts-space', this.props.className), style: { height: this.props.height || '100%', width: this.props.width || '100%' } });
    }
}
//# sourceMappingURL=TS_Space.js.map